import { Capacitor } from '@capacitor/core';
// Si usas plugin para Android Intents, lo importas aquí
// import { IntentLauncher } from '@awesome-cordova-plugins/android-intent';

// Para leer archivo, si luego haces plugin nativo:
// import { Filesystem } from '@capacitor/filesystem';

export const lanzarPago = async (amountBuy, providerId = '0001') => {
  const action = 'BANCARD_CRDB_PAGAR';
  const extras = {
    amountBuy: String(amountBuy),
    providerId: providerId
  };

  if (Capacitor.isNativePlatform()) {
    console.log(`👉 (Android) Disparando Intent de Pago: ${action}`, extras);
    // Aquí deberías usar el plugin real, por ejemplo:
    // await IntentLauncher.startActivity({ action, extras });
  } else {
    console.log(`(Simulado en web) Intent de Pago: ${action}`, extras);
    return { responseCode: '00' };
  }
};

export const lanzarImpresion = async (lineas) => {
  const action = 'BANCARD_IC2_IMPRIMIR';
  const extras = {
    print: JSON.stringify(lineas) // lineas = array de objetos [{type, size, align, value, bold}]
  };

  if (Capacitor.isNativePlatform()) {
    console.log(`👉 (Android) Disparando Intent de Impresión: ${action}`, extras);
    // await IntentLauncher.startActivity({ action, extras });
  } else {
    console.log(`(Simulado en web) Intent de Impresión: ${action}`, extras);
  }
};

export const obtenerModeloPOS = async () => {
  const filePath = '/storage/emulated/0/INFO_POS.TXT';

  if (Capacitor.isNativePlatform()) {
    console.log(`👉 (Android) Leyendo archivo modelo POS: ${filePath}`);
    // Ejemplo si tuvieras plugin nativo:
    // const contents = await Filesystem.readFile({ path: filePath });
    // const lines = contents.data.split('\n');
    // const modelLine = lines.find(line => line.startsWith('MODEL='));
    // const serialLine = lines.find(line => line.startsWith('SERIAL='));
    // return {
    //   model: modelLine?.split('=')[1].trim(),
    //   serial: serialLine?.split('=')[1].trim()
    // };
    return { model: 'F20', serial: 'F20MP1234567890 (simulado)' };
  } else {
    console.log(`(Simulado en web) Leyendo modelo POS`);
    return { model: 'SIMULADOR', serial: '0000000000' };
  }
};
